import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { pega_dados_carteirinhas } from "../../services/api";
import './tabelas_matricula.css';

const Carteirinhas_tabelas = (props) => {
    const [data26, setData26] = useState([]);
    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    const fetchData = async () => {
        try {
            const response = await pega_dados_carteirinhas(props.di, props.df);
            setData26(response || []);
        } catch (error) { console.error(error); }
    };

    useEffect(() => { fetchData(); }, [props.di, props.df]);

    // Função para replicar o range de cores do Google Charts
    const getPercentClass = (val, isTotal = false) => {
        if (isTotal) {
            if (val <= 50) return "bg-darkred";
            if (val <= 80) return "bg-red";
            if (val <= 90) return "bg-orange";
            return "bg-green";
        } else {
            if (val <= 50) return "bg-darkred";
            if (val <= 80) return "bg-red";
            if (val <= 90) return "bg-orange";
            return "bg-green";
        }
    };

    let t = { n: 0, solN: 0, r: 0, solR: 0, tot: 0, solTot: 0, ped: 0 };

    const processedData = data26.map(item => {
        const uni = unidades[parseInt(item.unidade)] || `Unid. ${item.unidade}`;
        const n = parseInt(item.novos) || 0; const solN = parseInt(item.novos_sol) || 0;
        const r = parseInt(item.renovados) || 0; const solR = parseInt(item.renovados_sol) || 0;
        const tot = n + r; const solTot = solN + solR;
        const ped = parseInt(item.pedidos) || 0;

        t.n += n; t.solN += solN; t.r += r; t.solR += solR; t.tot += tot; t.solTot += solTot; t.ped += ped;

        return {
            uni, n, solN, pN: n > 0 ? (solN / n) * 100 : 0,
            r, solR, pR: r > 0 ? (solR / r) * 100 : 0,
            tot, solTot, pT: tot > 0 ? (solTot / tot) * 100 : 0, ped
        };
    }).sort((a, b) => a.uni.localeCompare(b.uni));

    return (
        <div className="mt-3">
            <h4 className="mb-3 fw-light text-secondary">Solicitação de Carteirinhas</h4>

            <div className="alert alert-secondary small text-start border-0 shadow-sm" style={{ maxWidth: '600px' }}>
                <strong className="d-block mb-1">Nota rápida:</strong>
                • <b>"Sol"</b> indica quantas carteirinhas foram solicitadas.<br />
                • <b>"Pedidos"</b> é a quantidade enviada ao fornecedor (inclui 2ª via).
            </div>

            <div className="table-responsive shadow-sm rounded border">
                <Table hover bordered className="text-center align-middle bg-white m-0 tabela-matriculas">
                    <thead className="table-dark">
                        <tr>
                            <th className="text-start ps-3">UNIDADE</th>
                            <th>N 27</th><th>Sol N 27</th><th>N%</th>
                            <th>R 27</th><th>Sol R 27</th><th>R%</th>
                            <th>T 27</th><th>Sol T 27</th><th>T%</th>
                            <th>PEDIDOS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {processedData.map((row, idx) => (
                            <tr key={idx}>
                                <td className="text-start fw-bold bg-light ps-3">{row.uni}</td>
                                <td>{row.n}</td><td>{row.solN}</td><td className={getPercentClass(row.pN)}>{row.pN.toFixed(2)}%</td>
                                <td>{row.r}</td><td>{row.solR}</td><td className={getPercentClass(row.pR)}>{row.pR.toFixed(2)}%</td>
                                <td>{row.tot}</td><td>{row.solTot}</td><td className={getPercentClass(row.pT, true)}>{row.pT.toFixed(2)}%</td>
                                <td>{row.ped}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="fw-bolder border-top border-dark bg-light">
                        <tr>
                            <td className="text-start ps-3">TOTAL</td>
                            <td>{t.n}</td><td>{t.solN}</td><td className={getPercentClass((t.solN / t.n) * 100)}>{((t.solN / t.n) * 100).toFixed(2)}%</td>
                            <td>{t.r}</td><td>{t.solR}</td><td className={getPercentClass((t.solR / t.r) * 100)}>{((t.solR / t.r) * 100).toFixed(2)}%</td>
                            <td>{t.tot}</td><td>{t.solTot}</td><td className={getPercentClass((t.solTot / t.tot) * 100, true)}>{((t.solTot / t.tot) * 100).toFixed(2)}%</td>
                            <td>{t.ped}</td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </div>
    );
};
export default Carteirinhas_tabelas;